import { BaseUser } from './../../../core/models/base-user.model';
import { Component, OnInit, Input } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as StbSelectors from '../../../state/stb.selectors';
import { externalAppIds } from '../../../state/stb.reducer';

@Component({
    selector: 'cm-overlay',
    templateUrl: './overlay.component.html',
    styleUrls: ['./overlay.component.scss'],
    animations: [
        trigger('overlayTrigger', [
            state('fadeIn', style({
                opacity: '1',
            })),
            transition('void => *', [style({ opacity: '0' }), animate('500ms')]),
        ]),
    ],
    standalone: false
})
export class OverlayComponent implements OnInit {
  state = 'fadeIn';

  @Input() header = '';
  @Input() headerAvatar: BaseUser;
  @Input() headerCenter = true;
  @Input() width = 900;
  @Input() height = 550;

  @Input() showMessageCount = false;
  @Input() totalMessages: number;
  @Input() currentMessage: number;

  @Input() justifyTop = false;

  // When a non-external app (i.e. not Live TV / HDMI) is in the foreground,
  // there is no underlying TV picture to dim, so the overlay is shown over a
  // solid background image instead of the translucent backdrop.
  useSolidBackground$: Observable<boolean> = this.store$
    .select(StbSelectors.selectForegroundAppId)
    .pipe(
      map((appId) => !!appId && !externalAppIds.includes(appId))
    );

  constructor(private store$: Store) {}

  ngOnInit(): void {}
}
